'use client';

import Image from 'next/image';
import React from 'react';
import { useRouter } from 'next/navigation';

const PdpBackButtonMobile = () => {
  const router = useRouter();

  return (
    <Image
      src="/intstatic/icons/chevron-left.png"
      alt={'back-image'}
      width={10}
      height={17}
      className={'mt-1 d-md-none'}
      onClick={() => router.back()}
    />
  );
};

export default PdpBackButtonMobile;
